type InputVal = string | number | string[];

interface State {
  error?: string;
  mode?: "login" | "signup";
  fields?: ("store_id" | "email" | "password" | "first_name" | "last_name")[];
  store_presence?: boolean;
}

interface Credentials {
  email: InputVal;
  store_id: InputVal;
  password: InputVal;
  first_name?: InputVal;
  last_name?: InputVal;
  product_id?: InputVal;
  spree_user: {
    email: InputVal;
    password: InputVal;
  };
}

$(document).ready(() => {
  const $form = $("#patient-login");
  const $email = $form.find("[data-email]");
  const $pass = $form.find("[data-password]");
  const $passLabel = $form.find("[data-pass-label]");
  const $firstName = $form.find("[data-first-name]");
  const $lastName = $form.find("[data-last-name]");
  const $submit = $form.find("button[type=submit]");
  const storeId = $form.find("#spree_user_store_id").val();
  const $productId = $form.find("#spree_user_product_id").val();
  const $spinner = $('<i class="fa fa-spinner fa-spin"></i>');
  const $errorWrapper = $form.find("#form-error-wrapper");
  const $error = $(`
    <div class="alert alert-danger">
      <span class="close" data-dismiss="alert" aria-label="close">×</span>
      <span id="error-text"></span>
    </div>
  `);

  let setState = null;
  let getState = null;

  (() => {
    let state: State = {};
    getState = (): State => {
      return state;
    };
    setState = (newState: State) => {
      state = { ...state, ...newState };
    };
  })();

  $submit.text("Submit");

  $form.on("submit", e => {
    const emailVal = $email.val() + "";

    if (!emailVal || emailVal.length < 3 || emailVal.indexOf("@") === -1) {
      handleError("Please enter a valid email address");
    } else if (!getState().mode) {
      submitEmail($email.val())
        .then((state: State) => {
          setState(state);
          resetInputs();
          render();
        })
        .fail((jqXHR: JQueryXHR) => {
          handleError(jqXHR.responseText, jqXHR);
          render();
        });
    } else {
      submitCredentials(getCredentials())
        .then(redirect)
        .fail((jqXHR: JQueryXHR) => {
          handleError(jqXHR.responseText, jqXHR);
          render();
        });
    }

    e.preventDefault();
  });

  const handleError = (errorText?: string, jqXHR?: JQueryXHR): void => {
    $error
      .find("#error-text")
      .html(
        (jqXHR && jqXHR.status && jqXHR.status === 400) || !errorText
          ? "Something went wrong.  Please try again or <a href='https://fullscript.com/support' target='_blank'>contact support</a>"
          : errorText
      );
    $errorWrapper.append($error);
  };

  const getCredentials = (): Credentials => {
    return {
      store_id: storeId,
      email: $email.val(),
      password: $pass.val(),
      product_id: $productId,
      ...(getState().fields.indexOf("first_name") > -1 ? { first_name: $firstName.val() } : null),
      ...(getState().fields.indexOf("last_name") > -1 ? { last_name: $lastName.val() } : null),
      spree_user: {
        email: $email.val(),
        password: $pass.val(),
      },
    };
  };

  const render = (): void => {
    if (requiresNames()) {
      renderNames();
    }

    if (getState().mode) {
      $form.removeClass("patient-login--unknown-mode");
      if (getState().mode === "signup") {
        renderSignupState();
      } else if (getState().mode === "login") {
        renderLoginState();
      }
    }

    $submit
      .removeAttr("disabled")
      .find(".fa-spinner")
      .remove();
  };

  const resetInputs = (): void => {
    $pass.val("").focus();
    $firstName.val("");
    $lastName.val("");
  };

  const requiresNames = (): boolean => {
    if (!getState().fields) {
      return false;
    }

    return (
      getState().fields.indexOf("first_name") > -1 && getState().fields.indexOf("last_name") > -1
    );
  };

  const renderNames = (): void => {
    $firstName.removeAttr("disabled");
    $lastName.removeAttr("disabled");
    $form.addClass("patient-login--name-mode");
  };

  const renderSignupState = (): void => {
    $passLabel.text("Set Your Password *");
    $submit.text("Sign up");
    $form.addClass("patient-login--signup-mode");
  };

  const renderLoginState = (): void => {
    $submit.text(getState().mode === "signup" ? "Sign up" : "Login");
    $passLabel.text("Password *");
    $form.addClass("patient-login--login-mode");
  };

  const submitEmail = (email: InputVal) => {
    $errorWrapper.html("");
    $submit.attr("disabled", "true").prepend($spinner);
    return $.get(`/patient_signup_improvement/${email}/${storeId}`);
  };

  const submitCredentials = (credentials: Credentials) => {
    $errorWrapper.html("");
    $submit.attr("disabled", "true").prepend($spinner);
    return $.post("/patient_signup_improvement/", credentials);
  };

  const redirect = (): void => {
    window.location.replace(window.location.origin);
  };
});
